<div class="whatsapp-otp-step">
  <p class="main-question">
    <strong>Verifica tu número de WhatsApp</strong>
  </p>
  <p class="subtext" *ngIf="!whatsappError">Ingresa el código de 6 dígitos enviado a tu WhatsApp.</p>

  <!-- Alerta de error: número sin WhatsApp (se muestra arriba del formulario) -->
  <div *ngIf="whatsappError" class="whatsapp-error-alert">
    <mat-icon class="alert-icon">warning</mat-icon>
    <div class="alert-content">
      <strong>{{ whatsappErrorMessage }}</strong>
      <span>Por favor ingresa un número diferente con WhatsApp activo.</span>
    </div>
  </div>

  <!-- Teléfono actual con opción de editar (solo si NO hay error de WhatsApp) -->
  <div class="phone-display" *ngIf="!whatsappError && !showEditPhone">
    <span class="phone-label">Número:</span>
    <strong class="phone-value">{{ displayPhone }}</strong>
    <button
      *ngIf="isExpired || canResend"
      type="button"
      class="edit-btn"
      (click)="toggleEditPhone()"
      [disabled]="loading"
    >
      <mat-icon>edit</mat-icon>
      Cambiar
    </button>
  </div>

  <!-- Formulario para editar teléfono (se muestra automáticamente si hay error) -->
  <div *ngIf="showEditPhone || whatsappError" class="edit-phone-form">
    <form [formGroup]="editPhoneForm" (ngSubmit)="saveNewPhone()">
      <div class="phone-input-group">
        <!-- Selector de país -->
        <div class="country-selector" (click)="toggleCountryDropdown()">
          <img
            [src]="'assets/flags/' + selectedCountry.flag"
            [alt]="selectedCountry.name"
          />
          <span>{{ selectedCountry.code }}</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </div>

        <!-- Dropdown de países -->
        <div *ngIf="showCountryDropdown" class="country-dropdown">
          <div
            class="country-option"
            *ngFor="let country of countryPhoneOptions; trackBy: trackByCode"
            (click)="selectCountry(country)"
          >
            <img [src]="'assets/flags/' + country.flag" [alt]="country.name" />
            <span>{{ country.code }} {{ country.name }}</span>
          </div>
        </div>

        <!-- Input de teléfono -->
        <input
          type="tel"
          formControlName="newPhone"
          [placeholder]="phonePlaceholder"
          maxlength="30"
          autocomplete="tel"
          (input)="onPhoneInput($event)"
          (paste)="onPastePhone($event)"
          (blur)="onPhoneBlur()"
          [disabled]="editPhoneLoading"
        />
      </div>

      <!-- Error concreto si el numero no calza; si no, como escribirlo -->
      <p class="phone-hint phone-error" *ngIf="newPhoneError">{{ newPhoneError }}</p>
      <p class="phone-hint" *ngIf="!newPhoneError">{{ phoneHint }}</p>

      <div class="edit-phone-actions" [class.single-button]="whatsappError">
        <button
          *ngIf="!whatsappError"
          type="button"
          class="cancel-btn"
          (click)="cancelEditPhone()"
          [disabled]="editPhoneLoading"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="save-btn"
          [class.full-width]="whatsappError"
          [disabled]="!editPhoneForm.valid || editPhoneLoading"
        >
          {{ editPhoneLoading ? 'Enviando código...' : 'Enviar código de verificación' }}
        </button>
      </div>

      <!-- Botón volver cuando hay error de WhatsApp -->
      <button
        *ngIf="whatsappError"
        type="button"
        class="back-link"
        (click)="goBack()"
        [disabled]="editPhoneLoading"
      >
        <mat-icon>arrow_back</mat-icon>
        Volver al paso anterior
      </button>
    </form>
  </div>

  <!-- OTP Input (solo si no hay error de WhatsApp) -->
  <div class="otp-section" *ngIf="!showEditPhone && !whatsappError">
    <app-otp-input
      #otpInput
      [length]="6"
      [disabled]="loading"
      (codeComplete)="onCodeComplete($event)"
    ></app-otp-input>

    <!-- Countdown o estado expirado -->
    <div class="countdown-section">
      <div *ngIf="!isExpired" class="countdown-active">
        <span class="countdown-label">Código expira en:</span>
        <strong class="countdown-time">{{ countdownFormatted }}</strong>
      </div>

      <div *ngIf="isExpired" class="countdown-expired">
        <mat-icon class="warning-icon">warning</mat-icon>
        <span>El código ha expirado</span>
      </div>

      <button
        type="button"
        class="resend-btn"
        [disabled]="!canResend || loading"
        (click)="resendCode()"
      >
        {{ loading ? 'Enviando...' : canResend ? 'Solicitar nuevo código' : 'Solicitar nuevo código en ' + resendCountdownFormatted }}
      </button>
    </div>

    <!-- Botones de acción -->
    <div class="actions">
      <button
        type="button"
        class="back-btn"
        (click)="goBack()"
        [disabled]="loading"
      >
        Volver
      </button>
    </div>
  </div>
</div>
